export default {
  viewAll: '모두 보기',
  clearHistory: '기록 지우기',
  noGamesAvailable: '사용 가능한 게임이 없습니다',
  showMore: '더 보기',
  showLess: '접기',
  loading: '로딩 중...',
  error: '오류',
  retry: '다시 시도',
  cancel: '취소',
  confirm: '확인',
  save: '저장',
  delete: '삭제',
  edit: '편집',
  close: '닫기',
  submit: '제출',
  back: '뒤로',
  next: '다음',
  searchPlaceholder: '게임 검색...',
  search: '검색',
  noMoreGames: '더 이상 게임이 없습니다',
  backToTop: '맨 위로'
}; 